exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".border[data-v-0a8b0af8]{position:relative;border:1px solid #d3d3d3;border-radius:5px;padding:10px 5px 5px;margin:5px 0}.title[data-v-0a8b0af8]{padding-bottom:10px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a8b0af8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/epoq/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/_eng/globals/dcard.vue
// module id = 1782
// module chunks = 186